import React, { useState, useEffect  } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  FormGroup,
} from 'reactstrap';
import * as MyAPI from '../../../utils/MyAPI'
import HeaderAfter from '../parts/Header'
import HeaderBefore from '../../pre_login/parts/Header'
import Footer from '../parts/Footer'
import ApiSubHeader from '../parts/ApiSubHeader'
import Alert from 'react-s-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
// import AudioMagicEditor from './AudioMagicEditor'
import * as Helper from '../../../utils/Helper'
import * as UserActions from '../../../actions/UserActions'
import * as AbstructedApi from '../../../utils/AbstructedApi'


// AudioEditorTop
const AudioEditorTop = (props) => {

  let navigate = useNavigate();

  let dispatch = useDispatch();

  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });
  let user_state_createdAt = useSelector(state => {
    if (state.user && state.user.createdAt) {
      return state.user.createdAt
    } else {
      return ''
    }
  })
  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let [loading, setLoading] = useState(false)
  let [kanjiInput, setKanjiInput] = useState("")
  let [kanaInput, setKanaInput] = useState("")
  let [typeInput, setTypeInput] = useState("")
  let [deepSpeechTokens, setDeepSpeechTokens] = useState([]);
  let [apiIdSelected, setApiIdSelected] = useState("")
  let [vocabList, setVocabList] = useState([])
  let [skip, setSkip] = useState(0)
  let [totalVocabCount, setTotalVocabCount] = useState(0)
  let [searchText, setSearchText] = useState("")
  let [aiApiKey, setAiApiKey] = useState("")
  let [responseType, setResponseType] = useState("v2")

  // componentDidMount
  useEffect(() => {

    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // check login status
  let _loginCheck = async () => {

    if (!login_token) {

      let _rtnObj = await Helper.loginWithToken()
      if (_rtnObj.status === true) {

        let _login_token = _rtnObj.token_params.login_token
        dispatch(UserActions.loginWithEmail(_rtnObj.token_params))

        // true
        return _login_token

      } else {
        // not okay
        return null
      }
    }

    if (user_state_createdAt) {
      let diff = new Date().getTime() - user_state_createdAt.getTime()
      if ( diff < 60*60*1000 ) {
        return login_token
      }
    }

    let _rtnObj = await Helper.loginWithToken(login_token)

    if (_rtnObj.status === true) {

      // login ok
      dispatch(UserActions.loginWithEmail(_rtnObj.token_params))

    } else {
      return null
    }
  }

  // first script run
  let _firstScript = async () => {

    let _login_token = await _loginCheck()

    if (!_login_token){

      console.log("do nothing...")

    } else {

      // check subscription status
      if (subscription_status === "unknown") {
        let _obj = await AbstructedApi.checkSubscriptionStatus(_login_token)
        dispatch(UserActions.setSubscriptionStatus({
          subscription_status: _obj.subscription_status,
        }))

        subscription_status = _obj.subscription_status
      }

      if ( subscription_status === "active") {

        _getDeepSpeechTokens(_login_token)

      } else {

        // goto api_usage
        navigate("/api_usage")

        return
      }

    }
  }

  // get tokens
  let _getDeepSpeechTokens = async (_login_token) => {

    try {
      // logout on server
      let _results = await MyAPI.getDeepSpeechTokens({
        login_token: _login_token,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      // name to display
      let _list1 = _results.list1
      for ( let i=0; i<_list1.length; i++ ) {
        let _item = _list1[i]
        let _disp = _item.api_key.substr(0, 16)+"…"
        if ( _item.memo ) {
          if (_item.memo.length < 17) {
            _disp = _item.memo
          } else {
            _disp = _item.memo.substr(0, 16)+"…"
          }

        }
        _list1[i].disp_name = _disp
      }

      setDeepSpeechTokens(_list1)

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  // vocab list
  let _getVocabList = async ({
    ai_api_id,
    skip2,
  }) => {

    setLoading(true)

    try {

      if (!ai_api_id) {
        throw Error("no api is selected")
      }

      // logout on server
      let _results = await MyAPI.getVocabList({
        login_token: login_token,
        ai_api_id: ai_api_id,
        skip: skip2,
        search_text: searchText,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      if ( _results.list1 ) {
        setVocabList(_results.list1)
      } else {
        setVocabList([])
      }

      if (_results.count1) {
        setTotalVocabCount(_results.count1)
      } else {
        setTotalVocabCount(0)
      }

    } catch (err) {
      console.log("err: ", err)
    }

    setLoading(false)
  }

  // handle kanjiInput change
  let _kanjiInputChanged = (e) => {
    setKanjiInput(e.target.value)
  }

  // handle kanaInput change
  let _kanaInputChanged = (e) => {
    setKanaInput(e.target.value)
  }

  // handle typeInput change
  let _typeInputChanged = (e) => {
    setTypeInput(e.target.value)
  }

  // add a word into dictionary
  let _addVocab2Dict = async () => {

    setLoading(true)

    try {

      if (!apiIdSelected) {
        throw Error("no api is selected")
      }

      if (!kanjiInput) {
        throw Error("kanji is not detected")
      }

      if (!kanaInput) {
        throw Error("kana is not detected")
      }

      // logout on server
      let _results = await MyAPI.addOneWord2Dict({
        login_token: login_token,
        kanji: kanjiInput,
        kana: kanaInput,
        type: typeInput,
        ai_api_id: apiIdSelected,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      Alert.success("追加しました", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      // get vocab list again
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: skip
      })

      setTypeInput("")
      setKanaInput("")
      setKanjiInput("")

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }

  // api selected changed
  let _apiIdSelectedChanged = (e) => {

    setApiIdSelected(e.target.value)

    _getVocabList({
      ai_api_id: e.target.value,
      skip2: skip,
    })
  }

  // delete vocab
  let _deleteVocab = async (vocab_item) => {

    setLoading(true)

    try {

      if (!vocab_item) {
        throw Error("no api is selected")
      }

      // logout on server
      let _results = await MyAPI.deleteOneWordFromDict({
        login_token: login_token,
        vocab_id: vocab_item._id,
        // ai_api_id: apiIdSelected,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      Alert.success("削除しました", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      // get vocab list again
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: skip,
      })

      setTypeInput("")
      setKanaInput("")
      setKanjiInput("")

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }


  // update updatedAt
  let _updateUpdatedAt = async (item) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.updateVocabUpdatedAt({
        login_token: login_token,
        vocab_id: item._id,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      // get vocabs
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: 0,
      })

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }


  // toggle 同音異義語
  let _toggleDoOnIgigoExists = async (item) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.toggleDoOnIgigoExists({
        login_token: login_token,
        vocab_id: item._id,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      // get vocabs
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: 0,
      })

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }

  // _searchTextChanged
  let _searchTextChanged = (e) => {
    setSearchText(e.target.value)
  }

  // go next 100
  let _goNext = () => {

    let _skip = skip
    _skip = _skip + 100

    if (_skip > totalVocabCount) {
      _skip = totalVocabCount
    }

    setSkip(_skip)

    // get vocabs
    _getVocabList({
      ai_api_id: apiIdSelected,
      skip2: _skip,
    })
  }

  // go back
  let _goBack = () => {
    let _skip = skip
    _skip = _skip - 100
    if (_skip < 0) {
      _skip = 0
    }
    setSkip(_skip)

    // get vocabs
    _getVocabList({
      ai_api_id: apiIdSelected,
      skip2: _skip,
    })
  }

  // // toggle edit mode
  // let _toggleEditMode = () => {
  //   if ( editMode === "default" ) {
  //     setEditMode("interactive")
  //   } else {
  //     setEditMode("default")
  //   }
  // }

  // show alert
  let _showAlert = (message, type) => {

    if (type === "info") {
      Alert.info(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    } else if (type === "success") {
      Alert.success(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    } else if (type === "error") {
      Alert.error(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  // set loader
  let _setLoading = (arg) => {
    setLoading(arg)
  }

  // get vocabs again
  let _getVocabListAgain = (api_key_id) => {

    // get vocabs
    _getVocabList({
      ai_api_id: api_key_id,
      skip2: 0,
    })
  }

  // aiApiKey changed
  let _aiApiKeyChanged = (e) => {
    setAiApiKey(e.target.value)
  }

  // set ai_api_key
  let _setAiApiKey = async () => {

    setLoading(true)

    try {
      // logout on server
      let _results = await MyAPI.getApiInfoFromKey({
        ai_api_key: aiApiKey,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      if (_results.api_info) {
        setApiIdSelected(_results.api_info._id)
        setDeepSpeechTokens([_results.api_info])
      }

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }

  // toggle response type
  let _toggleResponseType = () => {

    if (responseType === "v2") {
      setResponseType("v3")
    } else {
      setResponseType("v2")
    }
  }

  return (
    <div>

      {/*<Header />*/}
      {login_token ? (
        <HeaderAfter />
      ) : (
        <HeaderBefore />
      )}

      {login_token && (
        <ApiSubHeader />
      )}


      {/* main */}
      <Container style={{
        marginTop: 40,
        minHeight: 300,
      }}>

        {/* select api keys */}
        <div>
          <Row style={{
            // backgroundColor: '#cccccc',
            marginTop: 30,
            marginBottom: 0,
          }}>

            <Col md="2" xs="12"/>
            <Col md="8" xs="12" style={{
              textAlign: 'left',
              marginLeft: 16,
            }}>
              APIキーをセットしてください
            </Col>
            <Col md="2" xs="12"/>
          </Row>

          {deepSpeechTokens.length > 0 ? (
            <Row style={{
              // backgroundColor: '#cccccc',
              marginTop: 5,
              marginBottom: 20,
            }}>

              <Col md="2" xs="12"/>
              <Col md="8" xs="12" style={{
                textAlign: 'left',
              }}>
                <Input onChange={_apiIdSelectedChanged}
                  type="select"
                  name="apiIdSelected"
                  value={apiIdSelected}>

                  <option
                    key={"dummy_api_key_id"}
                    value={""}>
                      選択してください
                  </option>

                  {deepSpeechTokens.map((item) => (
                    <option
                      key={item._id}
                      value={item._id}>
                        {item.disp_name}
                    </option>
                  ))}
                </Input>
              </Col>

              <Col md="2" xs="12"/>
            </Row>
          ) : (
            <Row style={{
              // backgroundColor: '#cccccc',
              marginTop: 5,
              marginBottom: 20,
            }}>

              <Col md="2" xs="12"/>
              <Col md="8" xs="12" style={{
                textAlign: 'left',
              }}>
                <InputGroup>

                  <Input onChange={_aiApiKeyChanged}
                    type="password"
                    name="aiApiKey"
                    value={aiApiKey}
                    placeholder="Put your API Key here."/>

                  <InputGroupAddon addonType="append" onClick={_setAiApiKey} style={{
                    cursor: 'pointer',
                  }}>
                    <InputGroupText>セット</InputGroupText>
                  </InputGroupAddon>

                </InputGroup>
              </Col>

              <Col md="2" xs="12"/>
            </Row>
          )}

          {/*<Row style={{
            marginTop: 20,
            marginBottom: 0,
          }}>

            <Col md="2" xs="12"/>
            <Col md="8" xs="12" style={{
              textAlign: 'left',
              marginLeft: 16,
            }}>

              <FontAwesomeIcon
                onClick={_toggleResponseType}
                icon={responseType === "v2" ? "toggle-off" : "toggle-on"}
                style={{
                  marginRight: 6,
                  cursor: 'pointer',
              }}/>
              <span>
                Bartかな漢字をテスト
              </span>

            </Col>
            <Col md="2" xs="12"/>
            </Row>*/}

        </div>


        {/* interactive mode */}
        {apiIdSelected && (
          <>
          </>
        )}

      </Container>

      <br/>

      {/* footer */}
      <Footer />

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default AudioEditorTop
